import { PRODUCT_TYPES, ProductTypes } from 'Types/ProductTypes'
import { useGetPlans } from 'Features/pricing/api/getPlans'
import { useMemo } from 'react'
import { capitalize } from 'Utils/capitalize'
import { useGetPlan } from 'Features/pricing/hooks/useGetPlan'
import { Plan } from 'Features/pricing/types/Plan'
import { PlanTypes } from 'Types/PlansTypes'
import { CurrenciesTypes } from 'Types/Currencies'

export const useFindPlanData = (enabled?: boolean) => {
  const isEnabled = enabled === undefined ? true : enabled
  const plansData = useGetPlans(isEnabled)
  const { findPlan } = useGetPlan()
  const plans = useMemo(() => {
    if (!(plansData.data instanceof Error)) {
      return plansData?.data
    }
  }, [plansData])

  const findCheckoutPlan = (
    billingCycleInMonths = 12
  ): {
    newPlanA: Plan | undefined
    newPlanB: Plan | undefined
    product: ProductTypes
  } => {
    const currency = sessionStorage.getItem('cur')?.toUpperCase()
    const planTypeA = capitalize(sessionStorage.getItem('planA'))
    const planTypeB = capitalize(sessionStorage.getItem('planB'))
    const prodA = sessionStorage.getItem('prodA')
    const prodB = sessionStorage.getItem('prodB')
    const allowedVisitsA = parseInt(sessionStorage.getItem('volA') || '')
    const allowedVisitsB = parseInt(sessionStorage.getItem('volB') || '')

    let product: ProductTypes
    let newPlanA: Plan | undefined
    let newPlanB: Plan | undefined
    if ((prodA === 'paid' || prodA === 'bot') && (prodB === 'paid' || prodB === 'bot')) {
      product = PRODUCT_TYPES.BUNDLE
      newPlanA = findPlan(
        plans || [],
        (planTypeA as PlanTypes) || 'Core',
        currency as CurrenciesTypes,
        PRODUCT_TYPES.PAID_MARKETING,
        allowedVisitsA,
        billingCycleInMonths
      )
      newPlanB = findPlan(
        plans || [],
        (planTypeB as PlanTypes) || 'Core',
        currency as CurrenciesTypes,
        PRODUCT_TYPES.BOT_ZAPPING,
        allowedVisitsB,
        billingCycleInMonths
      )
    } else {
      product = prodA === 'paid' ? PRODUCT_TYPES.PAID_MARKETING : PRODUCT_TYPES.BOT_ZAPPING
      newPlanA = findPlan(
        plans || [],
        (planTypeA as PlanTypes) || 'Core',
        currency as CurrenciesTypes,
        product,
        allowedVisitsA,
        billingCycleInMonths
      )
    }

    return { newPlanA, newPlanB, product }
  }

  return { findCheckoutPlan }
}
